export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_02.90f868f7.jpg";